import communityWalkthrough from '../../modules/community/walkthrough/nr.json';

export const NR = {
  translation: {
    ...communityWalkthrough,
  },
};
